<template>
  <div :class="['runs-box', {full:route === 'Runs' && !runs.list.length}]">
    <div class="table-loader" v-if="runs.loading && !runs.list.length">
      <ellipsis-loader></ellipsis-loader>
      <div class="loader-title">Loading Runs . . .</div>
      <div class="loader-text">{{ $t('dispatch.rsvpTable.loadingData.content') }}</div>
    </div>

    <div class="table-scroll" v-show="runs.list.length && !runs.loading">
      <table class="runs-table" id="runs-table">
        <thead v-if="!isMobile">
          <th class="check"></th>
          <th class="map"></th>
          <th class="ids">IDs</th>
          <th class="date">Pickup Time</th>
          <th class="date2">Last Dropoff Time</th>
          <th class="locs pickup">Pickup</th>
          <th class="locs dropoff">Dropoff</th>
          <th class="driver-payment">Driver Payment</th>
          <th class="pax">PAX</th>
          <th class="service">Service Type</th>
          <th class="action"></th>
        </thead>
        <tbody>
          <runs-row v-for="(run, i) in runs.list" :key="i" :run="run" :isMobile="isMobile"></runs-row>
        </tbody>
      </table>
    </div>

    <div class="empty-reservations" v-show="!runs.list.length && !runs.loading">
      <arrow-up></arrow-up>
      <div class="title">Oops. Looks like we found nothing.</div>
      <div class="content">
        We can't find any runs for that filter.<br/>
        Please use another one from the form at the top.
      </div>
    </div>
  </div>
</template>

<script>
import ArrowUp from '@/components/Partials/LoadingAnimation/ArrowUp'
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'
import RunsRow from './RunsRow'

export default {
  name: 'runs-table',
  components: { ArrowUp, EllipsisLoader, RunsRow },
  data () {
    return {
      isMobile: false
    }
  },
  computed: {
    route () { return this.$route.name },
    runs () { return this.$store.state.runs },
    airports () { return this.$store.state.airports.list },
    selected: {
      get () { return this.runs.selected },
      set (x) { this.$store.commit('runs/setRunsDetails', {selected: x}) }
    }
  },
  methods: {
    getAddress (loc) {
      let index = this.airports.findIndex(x => x.geofenceId === loc.geofenceId)
      if (index > -1) return this.airports[index].title
      return loc.title
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  mounted () {
    this.setScreenSize()
  },
  watch: {
    'runs.list': function (val) {
      if (val.length) {
        this.$nextTick(() => {
          setTimeout(() => {
            let pickup = document.querySelector('#runs-table')
            document.querySelector('#runs-table thead .pickup')
              .setAttribute('style', `width:${(pickup.offsetWidth - 400) / 2}px`)
            let dropoff = document.querySelector('#runs-table')
            document.querySelector('#runs-table thead .dropoff')
              .setAttribute('style', `width:${(pickup.offsetWidth - 400) / 2}px`)
          }, 100)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.runs-box{
  position: relative;
  height: 100%;
  width: calc(100% - 1px);

  &.full{ height:auto; }
}
.table-loader{
  position: relative;
  width: 100%;
  margin: 50px auto;
  text-align: center;

  .loader-title{
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  .loader-text{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}
.table-scroll{
  height: 100%;
  overflow: auto;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.runs-table{
  border-collapse: collapse;
  width: 100%;
  overflow: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  height: 100%;
  display: table-footer-group;

  thead{
    width: 100%;
    color: #8DA0A9;
    font-size: 12px;
    border-bottom: 1px solid rgba(0,0,0, .3);

    th{
      padding: 5px;
      position: sticky;
      position: -webkit-sticky;
      top: 0;
      z-index: 2;
      background-color: #f5f5f5;
      text-transform: uppercase;

      &.sortable {
        cursor: pointer;
        text-decoration: underline;
        color: #333;
        transition: all 250ms;

        &.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }
      input{
        margin-top: 0;
        display: block;
        width: auto;
      }
    }
  }
  .check { width: 30px; }
  .map{ width: 40px; }
  .ids{ width: 90px; }
  .date{ width: 90px; }
  // .locs{ width: 100% }
  .driver-payment{ width: 125px; }
  .service{ width: 130px; }
}

.empty-reservations{
  max-width: 450px;
  margin: 50px auto;
  text-align: center;

  & .title {
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .content{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}

@media screen and (max-width: 430px) {
  .empty-reservations, .table-loader {
    margin: 10vh auto;
    width: 90%;
  }

.runs-table {
    display: table;
    tbody {
      width: 100%;
      padding: 60px 10px;
      display: block;
    }
  } 
}
</style>


// WEBPACK FOOTER //
// src/components/Runs/RunsList.vue